<template>
  <div class="comprehensive-report">
    <!-- 评阅等级（华宸为 A/B/C/D，格子达为预估通过率） -->
    <div class="level-block">
      <div class="level-left">
        <div class="level-badge" :class="levelClass">{{ displayLevel }}</div>
      </div>
      <div class="level-right">
        <div class="level-title">{{ paperName || "论文AI评阅" }}</div>
        <div class="level-desc">
          {{ isPassRate ? "预估通过率" : "综合评阅等级" }}
        </div>
      </div>
    </div>

    <!-- 核心问题 -->
    <div v-if="coreProblems.length" class="block">
      <div class="block-title">核心问题</div>
      <ul class="problem-list">
        <li v-for="(p, i) in coreProblems" :key="i" class="problem-item">
          {{ p }}
        </li>
      </ul>
    </div>

    <!-- 基本指标 8 项 -->
    <div v-if="overallItems.length" class="block">
      <div class="block-title">基本指标</div>
      <div class="quota-content">
        <div
          v-for="(item, i) in overallItems"
          :key="i"
          class="quota-item"
        >
          <div class="quota-name">{{ item.itemName }}</div>
          <div class="quota-value">{{ item.content }}</div>
        </div>
      </div>
    </div>

    <!-- 报告单下载 -->
    <div v-if="reviewFileUrl || dimensionFileUrl || docxUrl" class="block">
      <div class="block-title">报告单下载</div>
      <div class="download-row">
        <a
          v-if="reviewFileUrl"
          :href="reviewFileUrl"
          target="_blank"
          class="download-link"
          >综合智评报告单</a
        >
        <a
          v-if="dimensionFileUrl"
          :href="dimensionFileUrl"
          target="_blank"
          class="download-link"
          >评分要素报告单</a
        >
        <a v-if="docxUrl" :href="docxUrl" target="_blank" class="download-link"
          >论文对照稿</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComprehensiveReport",
  props: {
    evaluation: {
      type: [String, Number],
      default: "",
    },
    coreProblems: {
      type: Array,
      default: () => [],
    },
    overallItems: {
      type: Array,
      default: () => [],
    },
    reviewFileUrl: {
      type: String,
      default: "",
    },
    dimensionFileUrl: {
      type: String,
      default: "",
    },
    docxUrl: {
      type: String,
      default: "",
    },
    paperName: {
      type: String,
      default: "",
    },
  },
  computed: {
    // 是否为格子达的预估通过率（含 % 或数字）
    isPassRate() {
      return (
        typeof this.evaluation === "number" ||
        (typeof this.evaluation === "string" &&
          /%/.test(this.evaluation))
      );
    },
    displayLevel() {
      return this.evaluation === "" || this.evaluation === null
        ? "—"
        : this.evaluation;
    },
    // 仅华宸 A/B/C/D 使用等级配色
    levelClass() {
      if (this.isPassRate) return "level-rate";
      const map = {
        A: "level-a",
        B: "level-b",
        C: "level-c",
        D: "level-d",
      };
      return map[(this.evaluation || "").toUpperCase()] || "level-default";
    },
  },
};
</script>

<style scoped lang="scss">
.comprehensive-report {
  .level-block {
    display: flex;
    align-items: center;
    background: #fafafa;
    border-radius: 8px;
    padding: 18px 20px;
    margin-bottom: 20px;
    .level-left {
      margin-right: 24px;
      .level-badge {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 40px;
        font-weight: 700;
        color: #fff;
        line-height: 1;
        text-align: center;
        &.level-a {
          background: #67c23a;
        }
        &.level-b {
          background: #409eff;
        }
        &.level-c {
          background: #e6a23c;
        }
        &.level-d {
          background: #f56c6c;
        }
        &.level-rate {
          background: #409eff;
          font-size: 22px;
        }
        &.level-default {
          background: #909399;
          font-size: 22px;
        }
      }
    }
    .level-right {
      .level-title {
        font-size: 18px;
        font-weight: 700;
        color: #1b2559;
      }
      .level-desc {
        margin-top: 6px;
        color: #909399;
        font-size: 14px;
      }
    }
  }

  .block {
    margin-bottom: 22px;
    .block-title {
      position: relative;
      font-size: 16px;
      font-weight: 700;
      color: #1b2559;
      padding-left: 10px;
      margin-bottom: 14px;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 5px;
        height: 16px;
        background: #0054e6;
        border-radius: 12px;
        transform: translateY(-50%);
      }
    }
  }

  .problem-list {
    margin: 0;
    padding-left: 18px;
    .problem-item {
      color: #434343;
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 6px;
    }
  }

  .quota-content {
    border: 1px solid #dee0e3;
    border-radius: 12px;
    padding: 16px 16px 6px;
    .quota-item {
      margin-bottom: 12px;
      .quota-name {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 4px;
      }
      .quota-value {
        font-size: 14px;
        color: #606266;
        line-height: 22px;
        word-break: break-all;
      }
    }
  }

  .download-row {
    .download-link {
      display: inline-block;
      margin-right: 18px;
      color: #409eff;
      font-size: 14px;
    }
  }
}
</style>
